import React, { FC } from "react";
import type { PaymentChannelsMaintainTheIntegrityProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const PaymentChannelsMaintainTheIntegrity: FC<
  PaymentChannelsMaintainTheIntegrityProps
> = ({ content, cover }) => {
  return (
    <section className="paymentChannelsMaintainTheIntegrity">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={495} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="paymentChannelsMaintainTheIntegrity--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
